import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
  refreshView as refreshViewAction
} from "admin-on-rest";
import Avatar from "material-ui/Avatar";
import {listStyle} from "./style";
import ActionBar from "../../../components/CRM/ActionBar/";
import CustomerFilter from "./CustomerFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";
import {BMTheme} from "../../../BMTheme";

const FullNameField = ({record = {}}) => (
  <div style={listStyle.textFieldContainer}>
    <Avatar color={BMTheme.customerAvatar.color} backgroundColor={BMTheme.customerAvatar.backgroundColor} style={listStyle.avatarSyle}>
      {record.first_name.charAt(0)}
      {record.last_name.charAt(0)}
    </Avatar>

    <span style={listStyle.textFieldStyle}>
      {record.first_name} {record.last_name}
    </span>
  </div>
);

class CustomerDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: []
  };

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    } else {
      this.props.record.selectedAll = value;
    }
    this.handleIdsSelection();
  };

  handleIdsSelection = () => {
    if (this.props.record.selectedAll === "none") {
      this.handleUnselectAll();
    } else {
      if (this.props.record.selectedAll === "all") {
        this.handleSelectAll();
      } else {
        if (
          this.props.record.selectedRow[0] ||
          this.props.record.selectedRow[0] === 0
        ) {
          this.handleSelectIds();
        } else {
          this.handleUnselectIds();
        }
      }
    }
  };

  handleUnselectAll = () => {
    this.props.record.ids = [];
    this.props.record.selectedAll = "";
    this.props.record.selectedRow = "";
    this.handleResetState();
    this.props.refreshView();
  };

  handleSelectAll = () => {
    this.props.record.ids = this.props.record.list.ids;
    this.props.record.selectedRow = [];
    this.props.record.selectedAll = "";
    this.handleResetState();
  };

  handleSelectIds = () => {
    this.props.record.list.ids.forEach((pair, index) => {
      this.props.record.selectedRow.forEach((value, key) => {
        if (value === index) {
          this.handleAddId(pair);
        }
        this.state.selectedIds.forEach((id, nb) => {
          if (id === pair) {
            if (!this.props.record.selectedRow.includes(index)) {
              this.handleRemoveId(id);
            }
          }
        });
      });
    });
  };

  handleAddId = pair => {
    if (this.state.selectedIds && !this.state.selectedIds.includes(pair)) {
      this.state.selectedIds.push(pair);
      this.props.record.ids = this.state.selectedIds;
    }
  };

  handleRemoveId = id => {
    function remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
    remove(this.state.selectedIds, id);
    this.props.record.ids = this.state.selectedIds;
  };

  handleUnselectIds = () => {
    this.props.record.ids = [];
    this.props.record.selectedRow = [];
    this.handleResetState();
    this.props.refreshView();
  };

  handleResetState = () => {
    this.setState({
      selectedIds: [],
      selectedAll: "",
      selectedRow: []
    });
  };

  render() {
    const props = {...this.props};
    props.record.list.ids.forEach((pair, index) => {
      const slipId = pair;
      if (slipId && props.record.data[slipId] !== null) {
        props.record.data[slipId].full_name =
          props.record.data[slipId].first_name +
          " " +
          props.record.data[slipId].last_name;
      }
    });
    
    return (
      <List
        title="resources.customers.name"
        {...props}
        actions={<ActionBar {...props} createButton={false} />}
        sort={{field: "name", order: "ASC"}}
        filters={<CustomerFilter />}
      >
        <Datagrid
          options={{
            multiSelectable: true,
            selectable: true,
            onRowSelection: this.handleRowSelection
          }}
          headerOptions={{
            adjustForCheckbox: true,
            displaySelectAll: true,
            enableSelectAll: true
          }}
          bodyOptions={{
            displayRowCheckbox: true,
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{
            selectable: true
          }}
        >
          <ReferenceField
            label="resources.customers.fields.storeName"
            source="kiosk_id"
            reference="kiosks"
          >
            <TextField source="name" />
          </ReferenceField>
          <FullNameField
            label="resources.customers.fields.customer"
            source="first_name,last_name"
          />
          <TextField label="resources.customers.fields.email" source="email" />
          <TextField label="resources.customers.fields.phone" source="phone" />
          <DateField
            label="resources.customers.fields.createdAt"
            source="created_at"
          />
          <DateField
            label="resources.customers.fields.updatedAt"
            source="updated_at"
          />

          <ActionMenu editButton={false} />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource]
  };
};

const CustomerDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(CustomerDataListBase);

export default CustomerDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/Customers/CustomerDataList.js